import { cn } from "@/lib/utils";

interface KeyValueTableProps {
  values: Array<{ name: string; value: string }>;
  className?: string;
  size?: "sm" | "xs";
  keyHeaderText?: string;
  valueHeaderText?: string;
}

export function KeyValueTable({
  values,
  className,
  size = "sm",
  keyHeaderText = "Name",
  valueHeaderText = "Value",
}: KeyValueTableProps) {
  if (values.length === 0) {
    return null;
  }

  const textSizeClass = size === "xs" ? "text-xs" : "text-sm";

  return (
    <div className={className}>
      <div className="grid grid-cols-2 border-b border-border">
        <div className={cn("py-2 text-foreground", textSizeClass)}>
          {keyHeaderText}
        </div>
        <div className={cn("py-2 text-foreground", textSizeClass)}>
          {valueHeaderText}
        </div>
      </div>
      {values.map((pair, index) => (
        <div
          key={`${pair.name}-${pair.value}`}
          className={cn(
            "grid grid-cols-2",
            index !== values.length - 1 && "border-b border-border",
          )}
        >
          <div
            className={cn(
              "py-2 font-mono text-muted-foreground",
              textSizeClass,
            )}
          >
            {pair.name}
          </div>
          <div
            className={cn(
              "py-2 font-mono text-muted-foreground",
              textSizeClass,
            )}
          >
            {pair.value}
          </div>
        </div>
      ))}
    </div>
  );
}
